import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {OrderService} from "../../../services/order.service";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-order-detail-modal',
    templateUrl: './order-detail-modal.component.html',
    styleUrls: ['./order-detail-modal.component.scss']
})
export class OrderDetailModalComponent implements OnInit {

    @Input() order;
    @Input() items;
    loading = false;

    constructor(
        private orderService: OrderService,
        public activeModal: NgbActiveModal,
        private toastrService: ToastrService,
    ) {
    }

    ngOnInit(): void {
    }

    delivered(): void {
        this.loading = true;
        this.orderService.delivered(this.order.id).subscribe({
            next: response => {
                this.loading = false;
                this.toastrService.success(response.message);
                this.activeModal.close();
            },
            error: err => {
                this.loading = false;
                this.toastrService.error(err);
            }
        })
    }

}
